// @flow

import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";

import TasksResults from "../../components/TasksResults/TasksResults";
import Page from "../../components/Page/Page";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import WithTracker from "../../components/WithTracker/WithTracker";

import type { userQueryResult } from "../../data/accounts";
import type { userResultsQueryResult } from "../../data/user-results";

import { withUserResults } from "../../data/user-results";
import { withUser } from "../../data/accounts";
import { NavLink } from "react-router-dom";

import "./Results.css";

type InnerProps = userResultsQueryResult & userQueryResult;

class InnerResults extends Component<InnerProps> {
  refreshData = (e: Event) => {
    ReactGA.event({ category: "Results", action: "Refresh" });
    e.preventDefault();
    if (this.props.userResultsData) {
      this.props.userResultsData.refetch();
    }
  };

  render() {
    const projects = this.props.userResultsData.allProjects;
    if (!projects) {
      return <div>Loading...</div>;
    }
    return (
      <div className="Results-Inner">
        <a href="#refresh" onClick={this.refreshData}>
          Refresh
        </a>
        {this.props.userData.user && this.props.userData.user.email ? null : (
          <div>
            <p>
              <br />
              <NavLink to="/signup" exact activeClassName="active">
                Sign up
              </NavLink>{" "}
              to save your data.
            </p>
          </div>
        )}
        {projects.map(
          project =>
            project.tasks.length > 0 && (
              <div key={project.id}>
                <h2>
                  {project.name} ({project.tasks.length} questions){" "}
                  <Link to={`/projects/${project.id}`}>→</Link>
                </h2>
                <TasksResults
                  tasks={project.tasks}
                  hasObjectiveAnswers={project.hasObjectiveAnswers}
                />
              </div>
            )
        )}
      </div>
    );
  }
}

const WrappedInnerResults = withUser(
  withUserResults(WithLoadingIndicator(InnerResults))
);

const Results = (props: userQueryResult) => (
  <Page className="Results" title="Your Results" fullWidth={true}>
    {props.userData.user ? (
      <WrappedInnerResults userId={props.userData.user.id} />
    ) : (
      <span>Loading...</span>
    )}
  </Page>
);

export default WithTracker(Results);



// WEBPACK FOOTER //
// ./src/pages/Results/Results.js